import {
  verifyForgotPasswordHash,
  setNewPassword,
} from "./set-new-password.service";

export const setNewPasswordService = {
  verifyForgotPasswordHash,
  setNewPassword,
};
